import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import './styles.css';
import FirmReviewItem from './components/FirmReviewItem';

const FirmReviewList = props => {
  const {
    user,
    reviews,
    hasPagination,
    delay,
    actions: {
      onClickReadAllHandler,
      handleClickReviewLink,
      handleBeforeReviewRatingUpdate,
      handleReviewRatingUpdate,
      handleReviewShowPreviousComments,
      handleReviewAddComment,
      handleReviewRemoveComment,
    },
  } = props;

  const { rows, rowsCount, perPage } = reviews;

  const linkReadAll = () => {
    return (
      rowsCount > perPage && (
        <div
          className="firm-review-list__show-all"
          onClick={onClickReadAllHandler}
        >
          Read All {rowsCount} Reviews{' '}
          <FontAwesomeIcon icon={faChevronDown} color="#f40" size="sm" />
        </div>
      )
    );
  };

  return (
    <div className="firm-review-list">
      {rows ? (
        <>
          <TransitionGroup className={null} appear={true}>
            {rows.map(review => {
              return (
                <CSSTransition
                  timeout={500 + delay}
                  classNames="animation__fade"
                  key={review.ReviewID}
                >
                  <FirmReviewItem
                    user={user}
                    key={review.ReviewID}
                    review={review}
                    isFetchingComments={review.isFetchingComments}
                    actions={{
                      handleClickReviewLink,
                      handleBeforeReviewRatingUpdate,
                      handleReviewRatingUpdate,
                      handleReviewShowPreviousComments,
                      handleReviewAddComment,
                      handleReviewRemoveComment,
                    }}
                  />
                </CSSTransition>
              );
            })}
          </TransitionGroup>
          {hasPagination ? null : linkReadAll()}
        </>
      ) : null}
    </div>
  );
};

FirmReviewList.defaultProps = {
  delay: 100,
  onClickReadAllHandler: () => {},
  onBeforeRatingUpdateHandler: () => {
    return true;
  },
};
export default FirmReviewList;
